import { appNames } from '@dvag/dfs-constant-config';
import { getContext, getToken } from '@dvag/dfs-orchestrator-client';
import { navigate, showMessage } from '@dvag/dfs-orchestrator-client/messengers';
import { useGetConsent, useGetFavorites, usePageAction } from '@dvag/dfs-ui-blocks/hooks';
import { useMemo } from 'react';

import featureFlag from 'service/featureFlag';

import { useGetPersonIdList } from './useGetPersonIdList';
import { useGetPolicies } from './useGetPolicies';

export const useGetFavoritesWithAction = (householdId?: string) => {
  const { checkHasConsent, checkHasAllAdultsConsent, checkHasAllPersonsBirthday } = useGetConsent(
    householdId,
    getToken,
  );

  const kundennummerList = useGetPersonIdList(householdId).data;
  const policiesQuery = useGetPolicies();
  const policies = policiesQuery.data?.policies;
  const pagesConfigOptions = useMemo(
    () => ({
      isFeatureOn: (feature: string) => !!featureFlag.gb?.isOn(feature),
      policies: policies ?? [],
    }),
    [policies],
  );

  const errorAlert = (message: string, title = ' ') =>
    showMessage(title, message, 'error', 'modal');

  const pagesQuery = useGetFavorites(getToken, true, true, pagesConfigOptions);

  const favorites = pagesQuery.data;

  const { pageAction } = usePageAction({
    householdId,
    getToken,
    getContext,
    kundennummerList,
    currentLocation: `/${appNames.advisor}${window.location.pathname}`,
    hasConsent: checkHasConsent,
    hasAllAdultsConsent: checkHasAllAdultsConsent,
    hasAllPersonsBirthDate: checkHasAllPersonsBirthday,
    errorToast: errorAlert,
    navigate: (url, nextUrl) => navigate(url, nextUrl, true),
  });

  const favoritesWithAction = useMemo(
    () =>
      favorites.map((favorite) => ({
        ...favorite,
        onClick: () => pageAction(favorite.navigationCode),
      })),
    [favorites, pageAction],
  );

  return { data: favoritesWithAction, pageAction };
};
